import React from "react";
import cx from "classnames";

class DialogFooter extends React.Component {
  static defaultProps = {
    baseClassName: "si-c-dialog__footer",
  };

  render() {
    var { children, baseClassName, className, style } = this.props;

    return (
      <div className={cx(baseClassName, className)} style={style}>
        {children}
      </div>
    );
  }
}

export default DialogFooter;
